export const constApi = {
  //#region Enum
  AUTENTICATION: "/api-/Authentication",
  ENUM: "/TEnum",
  ENUMID: "/TEnum/",
  ENUMTIPO: "/TEnum/Tipo",
  ENUMFILT: "/TEnum/Filt",
  ENUMUBIGEOT: "/TEnum/Ubigeo",
  ENUMUBIGEO: "/UbiGeo/List",
  //#endregion

  //#region
  FILIALIST: "/Filiales/List",
  FILIALISTEC: "/ItemsEC/Filiales/List",
  //#endregion

  //#region Items
  ITEMSLIST: "/ItemsEC/List",
  ITEMSEC_LIST: "/ItemsEC/List",
  ITEMSECLIC: "/ItemsEC/Clic/",
  ITEMSECCAT: "/ItemsEC/Catalogo/List",
  //#endregion

  //CatalogoEc
  CATALOGOEC: "/Catalogo/EC_List",
  //

  //Cuentas_Bancos
  CTASBANCOS: "/Cuentas_Bancos/List",
  //

  //contactenos
  CONTACTE: "/Contactenos",
  //Usuarios Email Existe
  USUARIOSEMAILEXIST: "/Usuarios/EMailExiste",
  USUARIOSID: "/Usuarios/",
  TERCEROS: "/Terceros",
  TERCEROSID: "/Terceros/",
  TERCEROSLIST: "/Terceros/List",

  SUSCRITOS: "/Suscritos",
  SUSCRITOSID: "/Suscritos/",

  USUARIOSPSW: "/Usuarios/Psw",
  IZICARGO: "/Izi/Cargo",
  IZISHOP: "/Izi/Shpo",

  //#region REniec sunat
  RENIEC: "/RENIEC",
  RENIECAP: "/RENIEC/AP",
  SUNAT: "/SUNAT",
  //#endregion

  //#region Pedidos
  PEDIDOS: "/Pedidos",
  PEDIDOSID: "/Pedidos/",
  PEDIDOSLIST: "/Pedidos/List",
  //#endregion
};
